import { render } from "./VideoRealtor.vue?vue&type=template&id=793560e2&scoped=true"
const script = {}

import "./VideoRealtor.vue?vue&type=style&index=0&id=793560e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793560e2"]])

export default __exports__